import './index.scss'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'

import { App } from '@app/App'

if (import.meta.env.PROD) {
  const updateSW = registerSW({
    onNeedRefresh() {
      updateSW(true)
    },
  })

  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      updateSW()
    }
  })
}

const appElement = document.getElementById('root')
if (appElement) {
  const root = createRoot(appElement)
  root.render(<App />)
}
